import { Phone, Mail, Globe } from "lucide-react";
import { Link } from "react-router-dom";
import NewsletterSignup from "./NewsletterSignup";

// Use static path for optimized image delivery
const logo = "/images/atralend-logo.jpg";

const Footer = () => {
  return (
    <footer className="bg-primary text-primary-foreground">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div>
            <Link to="/" className="inline-block mb-4">
              <img 
                src={logo} 
                alt="Atralend - Mortgage Broker Canada" 
                className="h-20 w-auto object-contain bg-white rounded-lg p-2"
                width={63}
                height={80}
                loading="lazy"
              />
            </Link>
            <p className="text-primary-foreground/80 leading-relaxed">
              Your trusted mortgage partner helping Canadians achieve their homeownership dreams since day one.
            </p>
          </div>
          
          {/* Contact Info */}
          <div>
            <div className="text-lg font-semibold mb-4" role="heading" aria-level={2}>Contact Us</div>
            <div className="space-y-3">
              <a 
                href="tel:613-850-2237" 
                className="flex items-center gap-3 text-primary-foreground/80 hover:text-primary-foreground transition-colors"
              >
                <Phone className="w-5 h-5" />
                <span>613-850-2237</span>
              </a>
              <a 
                href="mailto:Johnny@atralend.com" 
                className="flex items-center gap-3 text-primary-foreground/80 hover:text-primary-foreground transition-colors"
              >
                <Mail className="w-5 h-5" />
                <span>Johnny@atralend.com</span>
              </a>
              <a 
                href="https://www.atralend.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="flex items-center gap-3 text-primary-foreground/80 hover:text-primary-foreground transition-colors"
              >
                <Globe className="w-5 h-5" />
                <span>www.atralend.com</span>
              </a>
            </div>
          </div>
          
          {/* Quick Links */}
          <div>
            <div className="text-lg font-semibold mb-4" role="heading" aria-level={2}>Our Services</div>
            <ul className="space-y-2 text-primary-foreground/80">
              <li>
                <Link to="/services/residential" className="hover:text-primary-foreground transition-colors">
                  Residential Mortgages
                </Link>
              </li>
              <li>
                <Link to="/services/investment-properties" className="hover:text-primary-foreground transition-colors">
                  Investment Properties
                </Link>
              </li>
              <li>
                <Link to="/services/commercial" className="hover:text-primary-foreground transition-colors">
                  Commercial Lending
                </Link>
              </li>
              <li>
                <Link to="/services/a-lending" className="hover:text-primary-foreground transition-colors">
                  A-Lending
                </Link>
              </li>
              <li>
                <Link to="/services/b-lending" className="hover:text-primary-foreground transition-colors">
                  B-Lending
                </Link>
              </li>
              <li>
                <Link to="/services/private-lending" className="hover:text-primary-foreground transition-colors">
                  Private Lending
                </Link>
              </li>
            </ul>
          </div>

          {/* Newsletter */}
          <div>
            <div className="text-lg font-semibold mb-4" role="heading" aria-level={2}>Stay Updated</div>
            <p className="text-primary-foreground/80 text-sm mb-4">
              Get mortgage tips, rate updates, and market insights delivered to your inbox.
            </p>
            <NewsletterSignup />
          </div>
        </div>
        
        {/* Bottom Bar */}
        <div className="border-t border-primary-foreground/20 mt-10 pt-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-primary-foreground/60 text-sm">
            <p>© {new Date().getFullYear()} Atralend. All rights reserved.</p>
            <div className="flex flex-wrap justify-center gap-4 sm:gap-6">
              <Link to="/about" className="hover:text-primary-foreground transition-colors">About</Link>
              <Link to="/blog" className="hover:text-primary-foreground transition-colors">Blog</Link>
              <Link to="/calculators" className="hover:text-primary-foreground transition-colors">Calculators</Link>
              <Link to="/contact" className="hover:text-primary-foreground transition-colors">Contact</Link>
              <Link to="/privacy-policy" className="hover:text-primary-foreground transition-colors">Privacy Policy</Link>
              <Link to="/terms-of-service" className="hover:text-primary-foreground transition-colors">Terms of Service</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
